import { MapperKeys } from '@common/utils';
import {
    APICustomFieldDescription,
    BackendCustomFieldDescription,
} from './types';

export const FACET_MISSING_KEY = 'missing' as const;

export const AVAILABLE_CFD_KEYS = [
    'scan',
    'size',
    'codec',
    'logos',
    'title',
    'bitRate',
    'episode',
    'checksum',
    'customer',
    'fileList',
    'qcStatus',
    'MPMStatus',
    'audionorm',
    'container',
    'ltoNumber',
    'reelcount',
    'colorspace',
    'qcReportID',
    'aspectratio',
    'billingExcl',
    'contentType',
    'inventory_id',
    'lto1Location',
    'lto2Location',
    'subtitleType',
    'userincharge',
    'audioLanguage',
    'checksumCheck',
    'patheLastSync',
    'addedInventory',
    'archiveRequest',
    'contractNumber',
    'creditLanguage',
    'isanIdentifier',
    'rtbBroadcaster',
    'workflowStatus',
    'commercialOffer',
    'mediaDefinition',
    'mezzanineformat',
    'optionalcontent',
    'patheMaterialID',
    'patheSyncStatus',
    'pictureLanguage',
    'subtitleVersion',
    'workflowHistory',
    'subtitleLanguage',
    'commercialEndDate',
    'markProxyErasedAt',
    'qcValidatedStreams',
    'preservation_category',
] as const;

export const CFDAPI_KEYS: MapperKeys<
    BackendCustomFieldDescription,
    APICustomFieldDescription
> = {
    label: 'label',
    order: 'order',
    hidden: 'hidden',
};

export const DEFAULT_CFDAPI: APICustomFieldDescription = {
    key: '',
    type: 'boolean', // Most common fallback
    label: '',
    order: 99, // Push unknown fields to the bottom
    hidden: false,
};

export const INITIAL_VISIBLE_COUNT = 5;
